import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  CognitoUser
} from 'amazon-cognito-identity-js';

function resendVerificationCode(username, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  const userData = {
    Username : username,
    Pool : userPool
  };

  Config.region = config.region;
  const cognitoUser = new CognitoUser(userData);
  const prom = new Promise((resolve, reject) => {
    cognitoUser.resendConfirmationCode((err, result) => {
      if (err) {
        reject(err);
      } else {
        resolve(result);
      }
    });
  });

  return prom;
}

export default function resendVerification(username, config) {
  return dispatch => dispatch({
    type: 'RESEND_VERIFICATION_FETCH',
    payload: resendVerificationCode(username, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/resendVerification.js